export const blockIconsMapsRestaurantNew = (
	<span className='material-symbols-outlined'>restaurant</span>
);
